import createKeccakHash from 'keccak';
export const keccak256 = input => {
  return createKeccakHash('keccak256').update(input).digest().toString('hex');
};
//# sourceMappingURL=keccak256.js.map